import { render, staticRenderFns } from "./DragModal.vue?vue&type=template&id=bafc98dc&scoped=true"
import script from "./DragModal.vue?vue&type=script&lang=js"
export * from "./DragModal.vue?vue&type=script&lang=js"
import style0 from "./DragModal.vue?vue&type=style&index=0&id=bafc98dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafc98dc",
  null
  
)

export default component.exports